import { LayoutRenderLayoutItemOptions } from '../../../models/cv-layout-render.model';

export enum MapLocationDesign {
	V1 = 'v1',
	V2 = 'v2'
}

export class MapLocationOptions extends LayoutRenderLayoutItemOptions {
	layout?: MapLocationDesign;

	constructor() {
		super();
		this.layout = MapLocationDesign.V1;
	}
}